import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39609f48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hang-ton-kho-thead" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "hang-ton-kho-header-row" }, [
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center hang-ton-kho-th-meta"
  }, "TT"),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center hang-ton-kho-th-meta break-word"
  }, " Mã VT "),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center hang-ton-kho-th-meta break-word"
  }, " Tên vật tư "),
  /*#__PURE__*/_createElementVNode("th", {
    rowspan: "2",
    class: "text-center hang-ton-kho-th-meta break-word"
  }, " ĐVT "),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "3",
    class: "text-center break-word"
  }, "Tồn đầu kỳ"),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "3",
    class: "text-center break-word"
  }, "Nhập trong kỳ"),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "3",
    class: "text-center break-word"
  }, "Xuất trong kỳ"),
  /*#__PURE__*/_createElementVNode("th", {
    colspan: "3",
    class: "text-center break-word"
  }, "Tồn cuối kỳ")
], -1))
const _hoisted_3 = { class: "hang-ton-kho-header-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Số lượng", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Đơn giá", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Thành tiền", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "hang-ton-kho-header-row" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic hang-ton-kho-th-meta" }, "A"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic hang-ton-kho-th-meta" }, "B"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic hang-ton-kho-th-meta" }, "C"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic hang-ton-kho-th-meta" }, "D"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "3 = 1 * 2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "4"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "5"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "6 = 4 * 5"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "7"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "8"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "9 = 7 * 8"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "10"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "11"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "12 = 10 * 11")
], -1))
const _hoisted_8 = { class: "hang-ton-kho-tbody" }
const _hoisted_9 = { class: "text-center break-word" }
const _hoisted_10 = { class: "break-word" }
const _hoisted_11 = { class: "break-word" }
const _hoisted_12 = { class: "break-word" }
const _hoisted_13 = { class: "text-end break-word" }
const _hoisted_14 = { class: "text-end break-word" }
const _hoisted_15 = { class: "text-end fw-bolder break-word" }
const _hoisted_16 = { class: "text-end break-word" }
const _hoisted_17 = { class: "text-end break-word" }
const _hoisted_18 = { class: "text-end fw-bolder break-word" }
const _hoisted_19 = { class: "text-end break-word" }
const _hoisted_20 = { class: "text-end break-word" }
const _hoisted_21 = { class: "text-end fw-bolder break-word" }
const _hoisted_22 = { class: "text-end break-word" }
const _hoisted_23 = { class: "text-end break-word" }
const _hoisted_24 = { class: "text-end fw-bolder break-word" }
const _hoisted_25 = { class: "bao-cao-table-total-row" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "4"
}, "Cộng", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_29 = { class: "text-end fw-bolder" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_32 = { class: "text-end fw-bolder" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_35 = { class: "text-end fw-bolder" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_38 = { class: "text-end fw-bolder" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "16",
  class: "text-center"
}, "Không có dữ liệu", -1))
const _hoisted_41 = [
  _hoisted_40
]

import { computed, PropType } from "vue";
import {
  ISoCanDoiVatTuTotalsResponseBase,
  IVatTuHangTonKhoItemV2ResponseBase,
} from "@/core/interfaces/ApiResponses";
import {
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import { REPORT_COLUMN_WIDTHS } from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";


export default /*#__PURE__*/_defineComponent({
  __name: 'HangTonKhoTable',
  props: {
  isPrintModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<IVatTuHangTonKhoItemV2ResponseBase[]>,
    required: true,
  },
  stripe: {
    type: Boolean,
    required: true,
  },
  rowStartIndex: {
    type: Number,
    default: 0,
  },
  totals: {
    type: Object as PropType<ISoCanDoiVatTuTotalsResponseBase | null>,
    default: null,
  },
},
  setup(__props) {

const COLUMN_WEIGHT_TOTAL =
  REPORT_COLUMN_WIDTHS.stt +
  REPORT_COLUMN_WIDTHS.ma +
  REPORT_COLUMN_WIDTHS.ten +
  REPORT_COLUMN_WIDTHS.dvt +
  (REPORT_COLUMN_WIDTHS.soLuong +
    REPORT_COLUMN_WIDTHS.donGia +
    REPORT_COLUMN_WIDTHS.thanhTien) *
    4;

const toColPercent = (weight: number) =>
  `${((weight / COLUMN_WEIGHT_TOTAL) * 100).toFixed(3)}%`;

const colW = {
  stt: toColPercent(REPORT_COLUMN_WIDTHS.stt),
  ma: toColPercent(REPORT_COLUMN_WIDTHS.ma),
  ten: toColPercent(REPORT_COLUMN_WIDTHS.ten),
  dvt: toColPercent(REPORT_COLUMN_WIDTHS.dvt),
  soLuong: toColPercent(REPORT_COLUMN_WIDTHS.soLuong),
  donGia: toColPercent(REPORT_COLUMN_WIDTHS.donGia),
  thanhTien: toColPercent(REPORT_COLUMN_WIDTHS.thanhTien),
};

const props = __props;

const totalDauKy = computed(() => {
  if (props.totals) {
    return formatAmount(Math.round(props.totals.beginning.amount));
  }

  let result = 0;

  props.items.forEach(({ beginning: { amount: so_tien_dau_ky } }) => {
    if (so_tien_dau_ky && !!+so_tien_dau_ky) {
      result += +so_tien_dau_ky;
    }
  });

  return formatAmount(Math.round(result));
});

const totalCuoiKy = computed(() => {
  if (props.totals) {
    return formatAmount(Math.round(props.totals.ending.amount));
  }

  let result = 0;

  props.items.forEach(({ ending: { amount: so_tien_cuoi_ky } }) => {
    if (so_tien_cuoi_ky && !!+so_tien_cuoi_ky) {
      result += +so_tien_cuoi_ky;
    }
  });

  return formatAmount(Math.round(result));
});

const totalNhapTrongKy = computed(() => {
  if (props.totals) {
    return formatAmount(Math.round(props.totals.imports.amount));
  }

  let result = 0;

  props.items.forEach(({ imports: { amount: nhap_trong_ky_tt } }) => {
    result += +nhap_trong_ky_tt;
  });

  return formatAmount(Math.round(result));
});

const totalXuatTrongKy = computed(() => {
  if (props.totals) {
    return formatAmount(Math.round(props.totals.exports.amount));
  }

  let result = 0;

  props.items.forEach(({ exports: { amount: xuat_trong_ky_tt } }) => {
    result += +xuat_trong_ky_tt;
  });

  return formatAmount(Math.round(result));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    style: { width: '100%', fontSize: '0.8rem' },
    class: _normalizeClass({
      'table-striped': __props.stripe,
      'bao-cao-table--print': __props.isPrintModal,
    })
  }, [
    _createElementVNode("colgroup", null, [
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.stt })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.ma })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.ten })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.dvt })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.soLuong })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.donGia })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: colW.thanhTien })
      }, null, 4)
    ]),
    _createElementVNode("thead", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("tr", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ], 64))
        }), 64))
      ]),
      _hoisted_7
    ]),
    _createElementVNode("tbody", _hoisted_8, [
      (__props.items.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.ma_vat_tu,
                class: _normalizeClass({
            'bao-cao-table-data-row': __props.isPrintModal,
            'bao-cao-table-data-row--last':
              __props.isPrintModal && index === __props.items.length - 1,
          })
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(__props.rowStartIndex + index + 1), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(item.ma_vat_tu), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(item.ten_vat_tu), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(item.don_vi_tinh), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(!!+item.beginning.quantity
                ? _unref(formatQuantity)(+item.beginning.quantity)
                : 0), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(item.beginning.price ? _unref(formatUnitPrice)(item.beginning.price) : 0), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(!!+item.beginning.amount
                ? _unref(formatAmount)(+item.beginning.amount)
                : 0), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatQuantity)(item.imports.quantity)), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatUnitPrice)(item.imports.price)), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatAmount)(Math.round(+item.imports.amount))), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(_unref(formatQuantity)(item.exports.quantity)), 1),
                _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatUnitPrice)(item.exports.price)), 1),
                _createElementVNode("td", _hoisted_21, _toDisplayString(_unref(formatAmount)(Math.round(+item.exports.amount))), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(item.ending.quantity ? _unref(formatQuantity)(+item.ending.quantity) : "-"), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(item.ending.price ? _unref(formatUnitPrice)(+item.ending.price) : "-"), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(item.ending.amount ? _unref(formatAmount)(+item.ending.amount) : "-"), 1)
              ], 2))
            }), 128)),
            _createElementVNode("tr", _hoisted_25, [
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _createElementVNode("td", _hoisted_29, _toDisplayString(totalDauKy.value), 1),
              _hoisted_30,
              _hoisted_31,
              _createElementVNode("td", _hoisted_32, _toDisplayString(totalNhapTrongKy.value), 1),
              _hoisted_33,
              _hoisted_34,
              _createElementVNode("td", _hoisted_35, _toDisplayString(totalXuatTrongKy.value), 1),
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("td", _hoisted_38, _toDisplayString(totalCuoiKy.value), 1)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("tr", _hoisted_39, _hoisted_41))
    ])
  ], 2))
}
}

})